var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlugins = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M18 13.501v8h-3c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 13 19.502h-2v-4h2c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 15 13.5h3zm3 5a.97.97 0 0 1 .712.287c.192.192.288.43.288.713s-.096.52-.288.712a.968.968 0 0 1-.712.288h-2v-2h2zM8.25 2.5a4.25 4.25 0 1 1 0 8.5H6.72l-.144.005a2.75 2.75 0 0 0-2.571 2.577L4 13.75a2.75 2.75 0 0 0 2.75 2.75l3.25-.001v2l-3.25.001a4.75 4.75 0 1 1 0-9.5l1.54-.002.114-.003A2.25 2.25 0 0 0 8.25 4.5H4a1 1 0 1 1 0-2h4.25zM21 14.501c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.713A.968.968 0 0 1 21 16.5h-2v-2h2z"
}))));
export default SvgIconPlugins;